
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Pagination,
  Avatar,
  Skeleton,
} from "@mui/material";
import { market_enquiry, rental_enquiry_list } from "../../../api/ControllApi";
import { ASSET_BASE } from "../../../utils/baseUrls";

const BASE_URL = ASSET_BASE;

const MarketinPlaceEnquiry = () => {
  const [enquiryList, setEnquiryList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(0);

  /* Get list */
  const getEnquiryList = () => {
    setLoading(true);

    market_enquiry()
      .then((res) => {
        setEnquiryList(res?.data?.material || []);
        setRowsPerPage(res?.data?.pagination.per_page)
      })
      .catch((err) => {

      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEnquiryList();
  }, []);


  const trimmedSearch = search.trim().toLowerCase();

  const filteredData = enquiryList.filter((item) => {
    // If search is empty, include all items
    if (!trimmedSearch) return true;

    const propertyName = item?.property?.name || "";
    const createdAt = item?.created_at || "";

    return (
      propertyName.toLowerCase().includes(trimmedSearch) ||
      createdAt.toLowerCase().includes(trimmedSearch)
    );
  });



  /* Pagination */
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  /* File image */
  const getFileImage = (property) => {
    // property null safety
    if (!property) {
      return "/assets/images/no-image.png";
    }

    const images = Array.isArray(property.image) ? property.image : [property.image].filter(Boolean);

    if (images.length > 0) {
      // Find first non-video image
      const firstImage = images.find(img => !isVideo(img));
      if (firstImage) return firstImage;

      // If all are videos, return the first one
      return images[0];
    }

    // Fallback image
    return "/assets/images/no-image.png";
  };


  return (
    <Box>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight={600}>
         Land Enquiry List
        </Typography>

        <TextField
          label="Search Land Enquiry..."
          variant="outlined"
          size="small"
          sx={{ width: { xs: "100%", sm: 250 } }}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "primary.light" }}>
            <TableRow >
              {/* <TableCell><strong>ID</strong></TableCell> */}
              <TableCell><strong>Property Name</strong></TableCell>
              <TableCell><strong>Date Of Enquiry</strong></TableCell>
              <TableCell><strong>Land Image</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading &&

              <TableRow>
                <TableCell colSpan={4} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            }

            {!loading && paginatedData.length > 0 &&
              paginatedData.map((enq) => {
                const property = enq?.property || {};
                const imageUrl = getFileImage(property);

                return (
                  <TableRow key={enq.id}>
                    {/* <TableCell>{enq.id}</TableCell> */}
                    <TableCell>{property?.name || "-"}</TableCell>
                    <TableCell>
                      {enq?.created_at
                        ? new Date(enq.created_at).toLocaleDateString("en-GB")
                        : "-"}
                    </TableCell>
                    <TableCell>
                    <Avatar
                    src={imageUrl}
                    variant="rounded"
                    sx={{ width: 70, height: 55 }}
                    />

                    </TableCell>
                  </TableRow>
                );
              })}

            {!loading && paginatedData.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No Land Enquiry List Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && filteredData.length > rowsPerPage && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default MarketinPlaceEnquiry;
